// src/plugins/notification.plugin.js
import NotificationService from '@/common/notification.service.js'

const NotificationPlugin = {
  install(Vue) {
    // Add to vue prototype so it's available in all components as this.$notification
    Vue.prototype.$notification = NotificationService
    
    // Also make it available globally
    Vue.notification = NotificationService
  }
}

export default NotificationPlugin